<template>
  <v-container class="faq-section-wrapper" fluid>
    <v-row>
      <v-col class="col-12 col-md-10 pa-md-0 texts-wrapper" offset-md="1">
        <h2 v-html="data.title"></h2>
        <h5 v-html="data.subtitle"></h5>
        <a
          class="button"
          :href="data.button.url"
          :target="data.button.external_url === true ? '_blank' : '_self'"
          >{{ data.button.text }}</a
        >
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12 col-md-10 pa-md-0" offset-md="1">
        <v-expansion-panels class="pt-md-5">
          <v-expansion-panel
            v-for="(question, i) in data.questionsList"
            :key="i"
            class="mb-2"
          >
            <v-expansion-panel-header>
              <div
                class="text-body title-question"
                v-html="question.question"
              />
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="text-body answer-question" v-html="question.answer" />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12 col-md-10 pa-md-0" offset-md="1">
        <a
          class="button"
          :href="data.button.url"
          :target="data.button.external_url === true ? '_blank' : '_self'"
          >{{ data.button.text }}</a
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'FaqSection',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.faq-section-wrapper
  padding-top: 100px
  padding-bottom: 220px
  .button
    background: #26D07C
    position: relative
    display: none
    width: 100%
    font-family: 'metropolisbold'
    font-style: normal
    font-weight: 700
    font-size: 16px
    line-height: 1
    text-transform: uppercase
    color: #003036
    text-align: center
    padding: 12px 0
    border-radius: 20px
    outline: none
    text-decoration: none
    transition: all 300ms ease-in-out
    &:hover
      background: #003036
      color: #ffffff
      transition: all 300ms ease-in-out
  .texts-wrapper
    position: relative
    margin-bottom: 50px
    h2
      display: inline-block
      font-family: 'metropolissemi_bold'
      font-weight: 600
      font-size: 32px
      line-height: 1.8
      color: #003036
      border-bottom: 4px solid #26D07C
      text-shadow: 0.5px 0.5px #003036
      margin-bottom: 30px
      ::v-deep
        span
          font-family: 'metropolisregular'
          font-weight: 400
    h5
      font-family: 'metropolisregular'
      font-style: normal
      font-weight: 400
      font-size: 16px
      line-height: 1
      color: #003036
    .button
      position: absolute
      display: inline-block
      width: auto
      align-items: center
      padding: 12px 48px
      right: 0
      bottom: 5%
      z-index: 2
  ::v-deep
    .v-expansion-panels
      .v-expansion-panel
        border: 1px solid #F2F2F3
        border-radius: 12px
        transition: all 300ms ease-in-out
        &:before,
        &:after
          display: none
        &.v-expansion-panel--active
          border: 1px solid #26D07C
          transition: all 300ms ease-in-out
          .v-expansion-panel-header
            .title-question
              color: #26D07C
        .v-expansion-panel-header
          .title-question
            font-family: 'metropolisbold' !important
            font-style: normal
            font-weight: 700
            font-size: 16px
            line-height: 1.4
            color: #003036
            span
              font-family: 'metropolisregular'
              font-weight: 400
        .v-expansion-panel-content
          .answer-question
            font-family: 'metropolisregular' !important
            font-style: normal
            font-weight: 400
            font-size: 14px
            line-height: 1.4
            color: #72737A
            span
              font-family: 'metropolisbold'
              font-weight: 700
  @media screen and (max-width: 959px)
    .button
      display: block
    .texts-wrapper
      margin-bottom: 30px
      h2
        text-align: center
        line-height: 1.4
      h5
        margin-bottom: 0
      .button
        display: none
    .v-expansion-panels
      margin-bottom: 50px
</style>
